<template>
  <div @click="handleFullScreen">
    <GmapMap
      ref="mapRef"
      :center="center"
      :options="options"
      :zoom="zoom"
      :style="{
        width: mapWidth + ' !important',
        height: mapHeight + ' !important',
      }"
    >
      <GmapMarker
        :clickable="false"
        :draggable="false"
        :position="markerLocation"
        :icon="icon"
      />
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
export default {
  name: "DragAddressMarkerOnMap",
  props: {
    mapWidth: {
      type: String,
      default: "100%",
    },
    mapHeight: {
      type: String,
      default: "100%",
    },
    center: {
      type: Object,
      default: function() {
        return {
          lat: 0,
          lng: 0,
        };
      },
    },
    addressDetail: {
      type: String,
      default: "",
    },
    zoom: {
      type: Number,
      default: 18,
    },
    options: {
      type: Object,
      default: function() {
        return {
          minZoom: 18,
          maxZoom: 19,
          scrollwheel: true,
          draggable: false,
          disableDoubleClickZoom: false,
          clickableIcons: false,
          disableDefaultUI: true,
          mapId: process.env.VUE_APP_GOOGLE_MAP_STYLE_ID,
        };
      },
    },
  },
  computed: {
    google: gmapApi,
    icon: function() {
      if (!this.google) {
        return null;
      }

      return {
        url: require("../assets/image/home-location.png"),
        scaledSize: new this.google.maps.Size(50, 50),
        origin: new this.google.maps.Point(0, 0),
        anchor: new this.google.maps.Point(25, 50),
      };
    },
  },
  watch: {
    center: function(val, oldval) {
      this.markerLocation = val;
    },
  },
  data: function() {
    return {
      markerLocation: this.center,
      map: undefined
    };
  },
  mounted: function() {
    this.initialMap();
  },
  methods: {
    // 初始化 Map
    initialMap() {
      const _this = this;
      this.$refs.mapRef.$mapPromise.then((map) => {
        let clearElementsTimer = setInterval(function() {
          let elements = document.querySelectorAll(".gmnoprint");
          for (let i = 0; i < elements.length; i++) {
            elements[i].remove();
          }
        }, 100);

        setTimeout(function() {
          clearInterval(clearElementsTimer);
        }, 3000);

        this.map = map

        _this.renderChangeAddressMarkerButtonElement(map);
        _this.renderCloseButtonElement(map);

        map.addListener("center_changed", function() {
          const center = map.getCenter();
          _this.markerLocation = {
            lat: center.lat(),
            lng: center.lng(),
          };
        });
      });
    },
    // 渲染 - 調整地址 Marker 按鈕元素
    renderChangeAddressMarkerButtonElement(map) {
      const controlUI = document.createElement("div");
      controlUI.id = "button_change_address_marker";
      controlUI.innerText = "調整位置";

      // map element
      const mapElement = map.getDiv().firstChild;
      const _this = this;

      controlUI.addEventListener("click", function(evt) {
        if (! _this.isFullscreen(mapElement)) {
          _this.requestFullscreen(mapElement);
        } else {
          if (this.getAttribute("action") === "confirm") {
            _this.setPosition(_this.markerLocation)
          }
          _this.exitFullscreen()
        }
      });

      map.controls[this.google.maps.ControlPosition.BOTTOM_CENTER].push(
        controlUI
      );
    },
    // 渲染 - 關閉 Button 按鈕元素
    renderCloseButtonElement(map) {
      const controlUI = document.createElement("div");
      controlUI.id = "button_close";
      controlUI.style.display = "none";

      const mapElement = map.getDiv().firstChild;
      const _this = this;

      controlUI.addEventListener("click", function(evt) {
        if (_this.isFullscreen(mapElement)) {
          _this.markerLocation = _this.center
          map.setCenter(_this.center)
          _this.exitFullscreen();
        }
      });

      map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(controlUI);
    },
    setPosition(position) {
      this.$emit("update:position", position)
    },
    handleFullScreen() {
      const mapElement = this.map.getDiv().firstChild
      if (this.isFullscreen(mapElement)) {
        return
      }
      document.getElementById('button_change_address_marker').click()
    },
    // 判斷目前是否為全螢幕
    isFullscreen(element) {
      return (
        (document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.mozFullScreenElement ||
          document.msFullscreenElement) == element
      );
    },
    // 請求全螢幕
    requestFullscreen(element) {
      const buttonClose = document.getElementById("button_close");
      const buttonChangeAddressMarker = document.getElementById(
        "button_change_address_marker"
      );

      buttonClose.style.display = "";
      buttonChangeAddressMarker.setAttribute("action", "confirm");
      buttonChangeAddressMarker.innerText = "確認位置";
      buttonChangeAddressMarker.classList.add('button_confirm')
      this.options.draggable = true;

      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen();
      }
    },
    // 離開全螢幕
    exitFullscreen() {
      const buttonClose = document.getElementById("button_close");
      const buttonChangeAddressMarker = document.getElementById(
        "button_change_address_marker"
      );

      buttonClose.style.display = "none";
      buttonChangeAddressMarker.setAttribute("action", "");
      buttonChangeAddressMarker.classList.remove("button_confirm");
      buttonChangeAddressMarker.innerText = "調整位置";
      this.options.draggable = false;
      this.options.minZoom = 18;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
  },
};
</script>

<style>
#button_close {
  width: 70px;
  height: 70px;
  margin-left: 15px;
  margin-top: 30px;
  background-size: 100% 100%;
  background-image: url("../assets/image/close.png");
  background-repeat: no-repeat;
}

#button_change_address_marker {
  background: -webkit-linear-gradient(
    rgba(250, 128, 10, 1),
    rgba(246, 0, 0, 1)
  );
  background: -o-linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  background: -moz-linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  background: linear-gradient(rgba(250, 128, 10, 1), rgba(246, 0, 0, 1));
  color: white;
  font-size: 14px;
  font-weight: 900;
  line-height: 25px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}

.button_confirm {
  width: 80%;
  font-size: 18px !important;
  margin-bottom: 50px !important;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
</style>
